import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { DEFAULT_TIME_RANGE_VALUE, TIME_RANGE_CUSTOM_VALUE } from '../const'
import type { ServiceMapCustomRangeApplied } from '../types/serviceMapCustomRangeApplied.interface'
import type { ServiceMapTimeRangeFilterValue } from '../types/serviceMapTimeRangeFilterValue.type'

type ServiceMapFiltersStore = {
  timeRangeValue: ServiceMapTimeRangeFilterValue
  customRangeApplied: ServiceMapCustomRangeApplied | null
  setTimeRangeFilter: (value: ServiceMapTimeRangeFilterValue, customRange?: ServiceMapCustomRangeApplied | null) => void
}

export const useServiceMapFiltersStore = create<ServiceMapFiltersStore>()(
  devtools(
    immer((set) => ({
      timeRangeValue: DEFAULT_TIME_RANGE_VALUE,
      customRangeApplied: null,

      setTimeRangeFilter: (value, customRange) =>
        set((state) => {
          state.timeRangeValue = value
          state.customRangeApplied = value === TIME_RANGE_CUSTOM_VALUE && customRange ? customRange : null
        }),
    })),
    {
      name: 'ServiceMapFiltersStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
